import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { LeaderboardListHeader } from './LeaderboardListHeader';
import { LeaderboardListItem } from './LeaderboardListItem';
import { LeaderBoardUser } from './leaderboardTypes';

interface LeaderboardListProps {
  list: LeaderBoardUser[];
  hideRating?: boolean;
}

export const LeaderboardList = ({ list, hideRating }: LeaderboardListProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'leaderboard' });

  return (
    <Box
      sx={{
        backgroundColor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.700'),
        borderRadius: '0 0 12px 12px',
        pt: 4,
        pb: 8,
      }}
    >
      <LeaderboardListHeader />
      <Box>
        {list.length ? (
          <>
            {list.map((item, index: number) => (
              <LeaderboardListItem item={item} index={index} key={item.id} hideRating={hideRating} />
            ))}
          </>
        ) : (
          <Box display="flex" justifyContent="center" py={10}>
            <Typography variant="text1" color="grey.600">
              {t('noUsers')}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
